import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ArchidriveMoveComponent } from './archidrive-move';

export const ArchidriveMoveModule: string = ng
    .module('archidrive-move', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('archidriveMoveComponent', ArchidriveMoveComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive-move/archidrive-move.module.ts